import React from "react";
import {AlertTooltip} from "../dashboard/rows/cells/base/AlertTooltip";
import { withTranslation } from 'react-i18next';

class DataExplorerComparisonTooltipClass extends AlertTooltip {
    render() {
        const { t } = this.props;
        let tooltipContent = this.tooltipContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <div className="col-6 m-0 p-0"><p
                            className="alert-tooltip-title">{this.props.metricName}<span></span>
                        </p></div>
                    </div>
                    {tooltipContent}
                </div>
            </div>
        )
    }

    tooltipContent() {
        const { t } = this.props;
        const { mainPeriodValue, comparisonPeriodValue, mainPeriodLabel, comparisonPeriodLabel } = this.props;
        
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    {mainPeriodLabel || t('data_explorer.tooltip.main_period', 'Período Principal')}: <span className="font-weight-bold">{mainPeriodValue}</span>
                    <br/>
                    {comparisonPeriodLabel || t('data_explorer.tooltip.comparison_period', 'Período Comparación')}: <span className="font-weight-bold">{comparisonPeriodValue}</span>
                </p>
            </div>
        );
    }
}

export const DataExplorerComparisonTooltip = withTranslation()(DataExplorerComparisonTooltipClass);
export default DataExplorerComparisonTooltip;

